import { React, useState } from "react";
import { Link, useNavigate, useLocation  } from "react-router-dom";
import Star from "../components/Star";
import { BsPlus, BsFillHeartFill, BsBellFill, BsCartFill} from "react-icons/bs";
import {confirm} from "../components/MegConfirmAlert";
import Sheet from 'react-modal-sheet';
import Product3 from "../components/Product3";
import { useTranslation } from 'react-i18next';
import { useAxios } from "../services/useAxios";
import { getCartCookie } from "../services/common";
import ProdList from "../components/ProdList";

export default function Product5 (props){
    const { t } = useTranslation();
    const location = useLocation();
    const navigate = useNavigate();  
    const [request] = useAxios();

    const lang = localStorage.getItem("language") || "ko";
    
    const [heart, setHeart] = useState(props.obj && props.obj.likeAt && props.obj.likeAt === 'Y');
    const handleHeart = async () => {
        const userData = localStorage.getItem("user");
        if (userData === null) {
            ConfirmPick();
            return;
        }else{
            const response = await request.post("/app/wishlist/procMyWishListAPI", {
                likeAt : heart?"N":"Y",
                goodsSn : props.obj.goodsSn,
                likeSn : props.obj.likeSn,
            });
            if(response.data.resultCode === 200){
                console.log(response.data)
                setHeart(!heart);
            }
        }
        
    }
    const ConfirmPick = async () => {
        const result = await confirm(t(`Message.common_login_page_msg1`) + t(`Message.common_login_page_msg2`), {okText : t(`Message.common_yes`) , cancelText :t(`Message.common_no`)});
        if(result){
            navigate('/LogIn', {
                state: { from: location },
              })
        }
    }

    const ConfirmAlrm = async () => {
        const result = await confirm('상품이 입고되면 알림톡으로 알려드립니다.\n재입고 알림을 받으시겠습니까?', {okText : '재입고 신청' , cancelText : t(`Message.common_no`)});
        if(result){
            alert(t(`Message.goods_fetch_restocking_req_sucss`), {okButtonStyle : 'secondary'}, {okText : t(`Message.common_ok`)});    
        }
    }

    const fn_clickOrder = () => {    
        setOpen(true);
    }

    const [isOpen, setOpen] = useState(false);


    if (props.type==='type13') {
        return(
            <div>
                <Link to={"/ProductDetail/"+props.obj.goodsSn} className="prodType13">
                    <p className="grad">{props.grad}</p>
                    <div className="imgWr">
                        { props.obj &&  (props.obj.soldoutAt === 'Y'  || props.obj.sleQy <= 0 )?
                            <>
                            <div className="soldOut">
                                <p>Sold Out</p>
                            </div> 
                            </>
                            :null
                        }
                        <img src={props.img} alt="상품명" />
                    </div>
                    <div className="infoWr">
                        <p className="prodName">{props.prodName}</p>
                        <div className="statusWr">
                            <Star type="star1" obj={props.obj} />
                            <p className="buy">{props.buy}개 구매</p>
                        </div>
                        <div className="dfcsG8">
                            <p className="cost">{props.cost}</p>
                            <p className="percent">{props.percent}%</p>
                            <p className="disprice">{props.disprice}</p>
                        </div>
                    </div>
                    <ul className="hc">
                        <li>
                            { props.heart &&
                                <button 
                                    className="pickBtn" 
                                    onClick={(e) => {
                                        e.preventDefault(); 
                                        e.stopPropagation(); 
                                        handleHeart();                                        
                                    }}>
                                    { heart ? (<BsFillHeartFill className="active" />) : (<BsFillHeartFill />) }
                                </button>
                            }
                            { props.obj &&  (props.obj.soldoutAt === 'Y'  || props.obj.sleQy <= 0 )?
                                <>
                                <button 
                                    className="bellBtn" 
                                    onClick={(e) => {
                                        e.preventDefault(); 
                                        e.stopPropagation();
                                        ConfirmAlrm();                                        
                                    }}>
                                    <BsBellFill className="active"/>
                                </button>
                                </>
                                :null
                            }
                        </li>
                        <li>
                            {props.cart &&
                                <button
                                    className="openCartModal" 
                                    onClick={(e) => {
                                        e.preventDefault(); 
                                        e.stopPropagation(); 
                                        fn_clickOrder();
                                    }}
                                >
                                    <BsPlus />
                                </button>
                            }
                        </li>
                    </ul>
                </Link>
                <ProdList id={props.obj.goodsSn} prodOpen={isOpen} setProdOpen={setOpen}></ProdList>
            </div>
        );
    }else if (props.type==='type14') {
        return(
            <div className="prodType14">
                <div className="imgWr">
                    <img src={props.img} alt="상품명" />
                </div>
                <div className="infoWr">
                    <p className="status">{props.status}</p>
                    <p className="prodName">{props.prodName}</p>
                    <p className="option">{props.option}</p>
                    <p className="disprice">{props.disprice}</p>
                </div>
            </div>
        )
    } else if (props.type==='type15') {
        return (
            <Link to={"/ProductDetail/"+props.obj.goodsSn}  className="prodType15">
                <div className="imgWr">
                    <img src={props.img} alt="상품명" />
                </div>
                <div className="infoWr">                    
                    <p className="prodName">{props.prodName}</p>
                    <p className="option">{props.option}</p>
                    <p className="deadline">{props.deadline}</p>
                </div>
            </Link>
        )
    }
};